import apiClient from "./apiClient";

const yardService = {
  async getYards(params = {}) {
    const {
      search = "",
      sort = "yardNo",
      order = "ASC",
      page = 1,
      limit = 10,
    } = params;

    const response = await apiClient.get("/yard", {
      params: { search, sort, order, page, limit },
    });
    return response?.data;
  },

  async getYardById(id) {
    if (!id) throw new Error("Yard ID is required");
    const response = await apiClient.get(`/yard/${id}`);
    return response?.data;
  },

  async getActiveYards() {
    const response = await apiClient.get("/yard/active");
    const payload = response?.data || {};
    const items = Array.isArray(payload?.data)
      ? payload.data
      : Array.isArray(payload?.items)
        ? payload.items
        : [];
    return { ...payload, items };
  },

  async createYard(data) {
    const response = await apiClient.post("/yard", data);
    return response?.data;
  },

  async updateYard(id, data) {
    if (!id) throw new Error("Yard ID is required");
    const response = await apiClient.patch(`/yard/${id}`, data);
    return response?.data;
  },

  async deleteYard(id) {
    if (!id) throw new Error("Yard ID is required");
    const response = await apiClient.delete(`/yard/${id}`);
    return response?.data;
  },
};

export default yardService;
